import PropTypes from "prop-types";
import React, { useEffect, useCallback, useRef, useState } from "react";
import { OffcanvasBody, OffcanvasHeader, Offcanvas, Button } from "reactstrap";
import SimpleBar from "simplebar-react";
import MetisMenu from "metismenujs";
import withRouter from "components/Common/withRouter";
import { Link, useLocation } from "react-router-dom";
import { withTranslation } from "react-i18next";
import Dashboard from "../../assets/images/sidebarnew/dashboard.svg";
import Customers from "../../assets/images/sidebarnew/customers.svg";
import Projects from "../../assets/images/sidebarnew/projects.svg";
import Timesheet from "../../assets/images/sidebarnew/timesheet.svg";
import Employee from "../../assets/images/sidebarnew/employees.svg";
import Assignments from "../../assets/images/sidebarnew/assignments.svg";
import Invoices from "../../assets/images/sidebarnew/invoices.svg";
import Subscription from "../../assets/images/sidebarnew/subscriptions.svg";
import UserManagement from "../../assets/images/sidebarnew/user_management.svg";
import Billing from "../../assets/images/sidebarnew/expenses.svg";
import Ticket from "../../assets/images/sidebarnew/ticket-solid.svg";
import { hasPermission, hasRolePermission } from "helpers/rolebased_helper";
import sidebarLogo from "../../assets/images/SidebarLogo.svg"

const SidebarContent = (props) => {
  const [isRight, setIsRight] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const toggleRightCanvas = () => {
    setIsRight(!isRight);
  };

  const location = useLocation();
  const ref = useRef();
  const path = location.pathname;

  const isAccountant = hasRolePermission(7);

  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag
        const parent3 = parent2.parentElement; // li tag
        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); // a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  const removeActivation = (items) => {
    for (let i = 0; i < items.length; ++i) {
      const item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.length && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }

        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active"); // li
            parent3.childNodes[0].classList.remove("mm-active");

            const parent4 = parent3.parentElement; // ul
            if (parent4) {
              parent4.classList.remove("mm-show"); // ul
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show"); // li
                parent5.childNodes[0].classList.remove("mm-active"); // a tag
              }
            }
          }
        }
      }
    }
  };

  const activeMenu = useCallback(() => {
    const pathName = location.pathname;
    let fullPath = pathName;

    if (
      fullPath.includes("/add-customer") ||
      fullPath.includes("/view-customer")
    ) {
      fullPath = "/customers";
    }

    switch (pathName) {
      case "/":
        fullPath = "/dashboard";
        break;
      case "/add-employee":
        fullPath = "/employees";
        break;
      case "/add-customer":
        fullPath = "/customers";
        break;
      default:
    }

    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    removeActivation(items);

    for (let i = 0; i < items.length; ++i) {
      if (fullPath === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
      const isSubMenu =
        items[i].pathname && fullPath.startsWith(items[i].pathname);
      if (isSubMenu) {
        matchingMenuItem = items[i];
        break;
      }
    }

    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [location.pathname, activateParentDropdown]);

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  useEffect(() => {
    new MetisMenu("#side-menu");
    activeMenu();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    activeMenu();
  }, [activeMenu]);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  return (
    <React.Fragment>
       <SimpleBar style={{ maxHeight: "100%" }} ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            {!isAccountant && (
              <li>
                <Link to="/dashboard" className="waves-effect">
                  <i>
                    <img src={Dashboard} alt="Dashboards" />
                  </i>
                  <span>{props.t("Dashboards")}</span>
                </Link>
              </li>
            )}

            {hasPermission("Customers", "View") && (
              <li>
                <Link to="/customers" className="waves-effect">
                  <i
                    className={path.includes("/customers") ? "active-menu" : ""}
                  >
                    <img src={Customers} alt="Customers" />
                  </i>
                  <span>{props.t("Customers")}</span>
                </Link>
              </li>
            )}
             {/* {hasPermission("Contacts", "view") && (
              <li>
                <Link to="/contacts" className="waves-effect">
                  <i
                    className={path.includes("/contacts") ? "active-menu" : ""}
                  >
                    <img src={Customers} alt="Customers" />
                  </i>
                  <span>{props.t("Contacts")}</span>
                </Link>
              </li>
            )} */}
              {hasPermission("Contacts", "view") && (
              <li>
                <Link to="/contacts" className="waves-effect">
                  <i>
                    <img src={Customers} alt="Contacts" />
                  </i>
                  <span>{props.t("Contacts")}</span>
                </Link>
              </li>
            )}

            {/* {hasPermission("Vendor", "View") && (
              <li>
                <Link to="/vendors" className="waves-effect">
                  <i>
                    <img src={Customers} alt="Vendors" />
                  </i>
                  <span>{props.t("Vendors")}</span>
                </Link>
              </li>
            )} */}

            {hasPermission("Employees", "View") && (
              <li>
                <Link to="/employees" className="waves-effect">
                  <i>
                    <img src={Employee} alt="Employees" />
                  </i>
                  <span>{props.t("Employees")}</span>
                </Link>
              </li>
            )}

            {hasPermission("Projects", "View") && (
              <li>
                <Link to="/projects" className="waves-effect">
                  <i>
                    <img src={Projects} alt="Projects" />
                  </i>
                  <span>{props.t("Projects")}</span>
                </Link>
              </li>
            )}

            {hasPermission("Assignments", "View") && (
              <li>
                <Link to="/assignments" className="waves-effect">
                  <i>
                    <img src={Assignments} alt="Assignments" />
                  </i>
                  <span>{props.t("Assignments")}</span>
                </Link>
              </li>
            )}

            {hasPermission("Timesheets", "View") && (
              <li>
                <Link to="/timesheets" className="waves-effect">
                  <i>
                    <img src={Timesheet} alt="Timesheet" />
                  </i>
                  <span>{props.t("Timesheets")}</span>
                </Link>
              </li>
            )}

            {hasPermission("Invoices", "View") && (
              <li>
                <Link to="/invoice" className="waves-effect">
                  <i>
                    <img src={Invoices} alt="Invoices" />
                  </i>
                  <span>{props.t("Invoices")}</span>
                </Link>
              </li>
            )}

            {hasPermission("Expenses", "View") && (
              <li>
                <Link to="/Billing" className="has-arrow waves-effect">
                  <i>
                    <img src={Billing} alt="Expenses" />
                  </i>
                  <span>{props.t("Expenses")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                  <li>
                    <Link to="/payments">{props.t("Payouts")}</Link>
                  </li>
                  <li>
                    <Link to="/receivables">{props.t("Receivables")}</Link>
                  </li>
                </ul>
              </li>
            )}

            {hasPermission("Administration", "View") && (
              <li>
                <Link to="/user-management" className="has-arrow waves-effect">
                  <i>
                    <img src={UserManagement} alt="Administration" />
                  </i>
                  <span>{props.t("Administration")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                  <li>
                    <Link to="/users">{props.t("Users")}</Link>
                  </li>

                  {/* {hasPermission(["/add-role"], "View") && (
                   <li>
                     <Link to="/add-role">{props.t("Add-role")}</Link>
                   </li>
                 )} */}
                  <li>
                    <Link to="/role">{props.t("Roles")}</Link>
                  </li>
                  <li>
                    <Link to="/modules">{props.t("Modules")}</Link>
                  </li>
                </ul>
              </li>
            )}

            {hasPermission("Subscriptions", "View") && (
              <li>
                <Link to="/subscription" className="waves-effect">
                  <i>
                    <img src={Subscription} alt="Subscriptions" />
                  </i>
                  <span>{props.t("Subscriptions")}</span>
                </Link>
              </li>
            )}

            {hasPermission("Tickets", "View") && (
              <li>
                <Link to="/tickets" className="waves-effect">
                  <i>
                    <img src={Ticket} alt="Tickets" />
                  </i>
                  <span>{props.t("Tickets")}</span>
                </Link>
              </li>
            )} 
              
            {hasPermission("Recruitment", "View") && (
              <li>
                <Link to="/user-management" className="has-arrow waves-effect">
                  <i>
                    <img src={UserManagement} alt="Recruitment" />
                  </i>
                  <span>{props.t("Recruitment")}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                  <li>
                    <Link to="/template">{props.t("Templates")}</Link>
                  </li>
                  <li>
                    <Link to="/job-postings">{props.t("Job Postings")}</Link>
                  </li>
                  <li>
                    <Link to="/candidate">{props.t("Candidates")}</Link>
                  </li>
                  <li>
                    <Link to="/interviews">{props.t("Interviews")}</Link>
                  </li>
                  <li>
                    <Link to="/resource-pool">{props.t("Resourse Pool")}</Link>
                  </li>
                  <li>
                    {/* <Link to="/recuirement-vendor">{props.t("vendors")}</Link>
                    🌟 New Submenu Under Vendors
                    <ul className="sub-menu ml-4" aria-expanded="false">
                      <li>
                        <Link to="/vendor-dashboard">
                          {props.t("Dashboard")}
                        </Link>
                      </li>
                      <li>
                        <Link to="/vendor-jobs">{props.t("Jobs")}</Link>
                      </li>

                      <li>
                        <Link to="/vendor-profile">{props.t("Profile")}</Link>
                      </li>
                    </ul> */}
                  </li>
                </ul>
              </li>
            )}

            {hasPermission("Certificates", "View") && (
              <li>
                <Link to="/certificates" className="waves-effect">
                  <i>
                    <img src={Invoices} alt="Certificates" />
                  </i>
                  <span>{props.t("Certificates")}</span>
                </Link>
              </li>
            )}
          </ul>
          {/* <div
            className="ps-4 py-5 "
            style={{
              display: isHovered ? "block" : "none",
              position: "sticky",
              bottom: 0,
              paddingBottom: "20px",
              background: "inherit",
             
            }}
          >
            <img
              src={sidebarLogo}
              alt="Sidebar Logo"
              style={{ width: "100%", maxWidth: "150px" }}
            />
          </div> */}
        </div>
      </SimpleBar>

      <Offcanvas
        direction="end"
        isOpen={isRight}
        toggle={toggleRightCanvas}
        id="offcanvasRight"
      >
        <OffcanvasHeader toggle={toggleRightCanvas}>
          Offcanvas Right
        </OffcanvasHeader>
        <OffcanvasBody>...</OffcanvasBody>
      </Offcanvas>
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.func.isRequired,
};

export default withRouter(withTranslation()(SidebarContent));
